import React from "react";
import styles from "./MainTabsModule.module.scss";
import { Tabs } from "../../components/Tabs/Tabs";
import { FilesModule } from "../FilesModule/FilesModule";
import { SettingsModule } from "../SettingsModule/SettingsModule";
import { PersonalModule } from "../PersonalModule/PersonalModule";

export const MainTabsModule = ({ newAssistant }) => {
  const [activeTab, setActiveTab] = React.useState(0);

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <FilesModule
            newAssistant={newAssistant}
          />
        );
      case 1:
        return <SettingsModule newAssistant={newAssistant} />;
      case 2:
        return <PersonalModule newAssistant={newAssistant} />;
      default:
        return "default";
    }
  };

  return (
    <div className={styles.container}>
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className={styles.content}>{renderContent()}</div>
    </div>
  );
};
